<app-enum-i18n [input]="stepsIds" (output)="setResources($event)"></app-enum-i18n>

<div class="container">
  <router-outlet></router-outlet>
</div>
